import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BlazeShare = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_23090_534562)">
          <path
            d="M5.23458 9.00877L0.746338 7.39848L15.1875 2.36206L12.9948 11.7154L9.36308 10.482L6.10824 13.7368L5.23458 9.00877Z"
            fill="white"
          />
          <path
            d="M6.10824 13.7368L5.23458 9.00877L0.746338 7.39848L15.1875 2.36206L12.9948 11.7154L9.36308 10.482M6.10824 13.7368L7.0333 9.694L9.36308 10.482M6.10824 13.7368L9.36308 10.482"
            stroke={color}
            strokeLinejoin="round"
          />
          <path
            d="M12.6094 5.0625L6.95312 9.59375L6.10833 13.3598L5.42188 9.125L12.6094 5.0625Z"
            fill={color}
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_23090_534562">
            <rect width={size} height={size} fill="white" transform="translate(0.0275879)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default BlazeShare
